<template>
    <ModalBase
        :name="name"
        :title="isEdit ? 'Editar frecuencia' : 'Crear frecuencia'"
        @close="$emit('close')"
    >
        <FrecuenciaForm :modelValue="localValue" @update:modelValue="localValue = $event" />

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="$emit('close')">Cancelar</Button>
                <Button  :loading="props.loading" :disabled="!isFormValid || props.loading" @click="handleSave">Guardar</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, computed, watch } from 'vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import FrecuenciaForm from './FrecuenciaForm.vue'

    const props = defineProps({
        name: { type: String, required: true },
        modelValue: {
            type: Object,
            default: () => ({ cantidad: null, frecuencia: '' })
        },
        loading: { type: Boolean, default: false }
    })
    const emit = defineEmits(['update:modelValue', 'save', 'close'])

    const localValue = ref({ ...props.modelValue })

    const isEdit = computed(() => !!props.modelValue?.id)

    const isFormValid = computed(() => {
        const val = localValue.value
        return val.cantidad != null && val.cantidad !== '' && val.frecuencia
    })

    watch(() => props.modelValue, val => {
        localValue.value = { ...val }
    }, { deep: true })

    function handleSave() {
        if (!isFormValid.value || props.loading) return
        emit('save', { ...localValue.value })
    }
</script>
